import {
  formatDynamicObject,
  safelyParse,
} from "../../../../../utilities/helper";
import {
  findNode,
  findTitleByReceivedId,
  stripHtml,
} from "../../../DynamicForm/helper";

// All Fields
// const componentMap=[text,dobAgeSelector,ageDateRange,TimePicker,ageRangeYear,checkbox,Date,eq5d5l,singleCheckbox,Time,dropdown,dispenseDrugKit,assignedDrugKit,numericPad,singleradio,genderRadioGroup,TimeTwo,file,HotSpot,None,visitdatepicker,singleSelectCheckbox,NRS,videourl,patientVisitDrugKitStatus,replaceDrugKit,vas,headertext,paragraphtext]

// export const buildFormFields = (answers = [], questionJson, allJsons) => {
//   return answers
//     ?.filter((item) => item?.displayAnswer)
//     ?.map((item, index) => {
//       const questionNode = findNode(questionJson, item?.questionId);

//       const fieldType = getFieldType(questionNode, item);

//       return {
//         answer_id: item?.id,
//         fieldName: getQuestionTitle(item, allJsons),
//         currentValue: getQuestionLabel(item, questionJson),
//         fieldType,

//         requestedValueFieldName: `${item.questionId}_requested`,
//         removeFieldName: `${item.questionId}_remove`,
//         removeValue: false,

//         isRequired: item?.isRequired || false,

//         // ✅ Pass options for UI
//         options: questionNode?.choices || [],

//         specialProps: getSpecialProps(questionNode),
//       };
//     });
// };

// export const buildFormFields = (
//   answers = [],
//   questionJson,
//   allJsons,
//   displayName = "",
// ) => {
//   return answers
//     ?.filter((item) => item?.displayAnswer)
//     ?.map((item) => {
//       const questionNode = findNode(questionJson, item?.questionId);

//       if (!questionNode) return null;

//       const fieldType = getFieldType(questionNode, item);
//       const title = getQuestionTitle(item, allJsons);

//       // 🔥 ✅ Apply special condition
//       if (
//         displayName === "Change Subject Visit" &&
//         !(
//           title?.toLowerCase().includes("screening date") &&
//           fieldType === "visitdatepicker"
//         )
//       ) {
//         return null;
//       }

//       return {
//         answer_id: item?.id,
//         fieldName: title,
//         currentValue: getQuestionLabel(item, questionJson),
//         fieldType,

//         requestedValueFieldName: `${item.questionId}_requested`,
//         removeFieldName: `${item.questionId}_remove`,
//         removeValue: false,

//         isRequired: item?.isRequired || false,

//         options: questionNode?.choices || [],
//         specialProps: getSpecialProps(questionNode),
//       };
//     })
//     .filter(Boolean); // ✅ remove nulls
// };

export const buildFormFields = (
  answers = [],
  questionJson,
  allJsons,
  displayName = "",
  visitsData = [],
  visitNumber,
) => {
  const fields = answers
    ?.filter((item) => item?.displayAnswer)
    ?.map((item) => {
      const questionNode = findNode(questionJson, item?.questionId);

      if (!questionNode) return null;

      const fieldType = getFieldType(questionNode, item);
      const title = getQuestionTitle(item, allJsons);

      if (
        displayName === "Change Subject Visit" &&
        fieldType !== "visitdatepicker" &&
        fieldType !== "eq5d5l"
      ) {
        return null;
      }

      if (
        displayName === "Change Questionnaire information" &&
        fieldType !== "visitdatepicker" &&
        fieldType !== "eq5d5l"
      ) {
        return null;
      }

      return {
        answer_id: item?.id,
        fieldName: title,
        currentValue: getQuestionLabel(item, questionJson),
        fieldType,

        requestedValueFieldName: `${item.questionId}_requested`,
        removeFieldName: `${item.questionId}_remove`,
        removeValue: false,

        isRequired: item?.isRequired || false,

        options: questionNode?.choices || [],
        specialProps: getSpecialProps(questionNode),
      };
    })
    .filter(Boolean);

  if (displayName === "Change Questionnaire information") {
    const visitOptions = visitsData.map((visit) => ({
      value: visit.id,
      label: visit.name,
    }));

    const selectedVisit = visitsData.find(
      (v) => String(v.id) === String(visitNumber),
    );

    fields.push({
      answer_id: "visit_name",

      fieldName: "Visit Name",

      currentValue: selectedVisit?.name || "",

      fieldType: "dropdown",

      requestedValueFieldName: `visit_name_requested`,
      removeFieldName: `visit_name_remove`,
      removeValue: false,

      isRequired: true,

      options: visitOptions,

      specialProps: {},
    });
  }

  return fields;
};

// export const buildPatientAttributeFields = (
//   patientAttributes = [],
//   questionnaireJson = {},
// ) => {
//   const elements = questionnaireJson?.pages?.flatMap(
//     (page) => page.elements || [],
//   );

//   return patientAttributes
//     ?.map((item) => {
//       const attributeId = item?.patientAttributeConfigurationDetail?.id;

//       // 🔍 Find matching element
//       const matchedElement = elements?.find(
//         (el) => el?.questionnaireJson?.selectedPatientAttribute === attributeId,
//       );

//       if (!matchedElement) return null;

//       const fieldType = matchedElement?.type; // e.g. "text"

//       return {
//         answer_id: item?.id,

//         // ✅ "Initials"
//         fieldName: matchedElement?.title,

//         // ✅ "m-s"
//         currentValue: item?.displayValue || item?.attributeValue,

//         // ✅ "text"
//         fieldType,

//         // ⚠️ using receivedId (since no questionId here)
//         requestedValueFieldName: `${matchedElement?.questionnaireJson?.selectedPatientAttribute}_requested`,
//         removeFieldName: `${matchedElement?.questionnaireJson?.selectedPatientAttribute}_remove`,
//         removeValue: false,

//         isRequired: false, // if needed you can extend this

//         // ✅ choices if exist
//         options:
//           matchedElement?.choices ||
//           matchedElement?.questionnaireJson?.choices ||
//           [],
//       };
//     })
//     .filter(Boolean); // remove nulls
// };

export const buildPatientAttributeFields = (
  patientAttributes = [],
  questionnaireJson = {},
) => {
  const elements =
    questionnaireJson?.pages?.flatMap((page) => page.elements || []) || [];

  const result = patientAttributes
    ?.map((item) => {
      const attributeId = item?.patientAttributeConfigurationDetail?.id;

      if (!attributeId) return null;

      const matchedElement = elements.find(
        (el) => el?.questionnaireJson?.selectedPatientAttribute === attributeId,
      );

      if (!matchedElement) return null;

      return {
        answer_id: item?.id,

        fieldName: matchedElement?.title || "",
        fieldType: matchedElement?.type || "text",

        currentValue: item?.displayValue || item?.attributeValue || "",

        requestedValueFieldName: `${attributeId}_requested`,
        removeFieldName: `${attributeId}_remove`,
        removeValue: false,

        isRequired: false,

        options:
          matchedElement?.choices ||
          matchedElement?.questionnaireJson?.choices ||
          [],
      };
    })
    .filter(Boolean); // remove nulls

  const uniqueResult = Array.from(
    new Map(result?.map((item) => [item.answer_id, item])).values(),
  );

  return uniqueResult;
};

const getQuestionTitle = (item, allJsons) => {
  const idRequired = item?.questionId;

  if (idRequired === "00000000-0000-0000-0000-000000000000") {
    return item?.questionDisplayText || item?.displayQuestion;
  }

  const foundTitle = allJsons?.find((json) =>
    findTitleByReceivedId(json, idRequired),
  );

  return findTitleByReceivedId(foundTitle, idRequired) || item?.displayQuestion;
};

const getQuestionLabel = (item, questionJson) => {
  const idRequired = item?.questionId;
  const key =
    idRequired === "00000000-0000-0000-0000-000000000000"
      ? item?.displayAnswer
      : findNode(questionJson, idRequired);
  if (key?.choices && Array.isArray(key?.choices) && key?.choices?.length > 0) {
    const foundOptionLabel = key?.choices?.find(
      (ele) => ele?.value == item?.displayAnswer,
    )?.text;
    return foundOptionLabel
      ? foundOptionLabel
      : formatDynamicObject(safelyParse(stripHtml(item?.displayAnswer)));
  }
  return formatDynamicObject(safelyParse(stripHtml(item?.displayAnswer)));
};

export const getFieldType = (questionNode, item) => {
  if (!questionNode) return "text";

  const eq5type = questionNode?.type;
  if (eq5type === "eq5d5l") {
    return "eq5d5l";
  }

  const type = questionNode?.inputType
    ? questionNode?.inputType?.toLowerCase?.()
    : questionNode?.type?.toLowerCase();

  switch (type) {
    case "text":
    case "textarea":
      return "text";

    case "date":
      return "Date";

    case "time":
      return "Time";

    case "datetime":
    case "visitdatepicker":
      return "visitdatepicker";

    case "number":
      return "numericPad";

    case "checkbox":
      return questionNode?.multiple ? "checkbox" : "singleCheckbox";

    case "radio":
      return "genderRadioGroup";

    case "select":
    case "dropdown":
      return "dropdown";

    case "file":
      return "file";
  }

  if (questionNode?.choices?.length) {
    return "dropdown";
  }

  if (isDobField(questionNode)) return "ageDateRange";
  if (isAgeField(questionNode)) return "ageRangeYear";
  if (isDobAgeSelector(questionNode)) return "dobAgeSelector";

  return "text";
};

const isDobField = (node) => {
  return node?.code === "DOB" || node?.title?.toLowerCase()?.includes("birth");
};

const isAgeField = (node) => {
  return node?.title?.toLowerCase()?.includes("age");
};

const isDobAgeSelector = (node) => {
  return node?.inputType === "dobAgeSelector" && node?.code === "DOB_TYPE";
};

const getSpecialProps = (questionNode) => {
  if (!questionNode) return {};

  return {
    maxLength: questionNode?.maxLength,
    minDate: questionNode?.minDate,
    maxDate: questionNode?.maxDate,
    minValue: questionNode?.minValue,
    maxValue: questionNode?.maxValue,
    content: questionNode?.content,
  };
};

// export const getRequestedValueLabel = (item, formData) => {
//   console.log("Item", item, formData);
//   if (!item || !formData) return "";

//   const rawValue = formData?.[item.requestedValueFieldName];

//   // 🔴 if no value
//   if (rawValue === undefined || rawValue === null || rawValue === "") {
//     return "";
//   }

//   // ✅ If options exist → map value to label
//   if (item?.options && Array.isArray(item.options)) {
//     const found = item.options.find(
//       (opt) => String(opt.value) === String(rawValue),
//     );

//     if (found) return found.text;
//   }

//   // ✅ fallback (same as your existing logic)
//   return formatDynamicObject(safelyParse(stripHtml(rawValue)));
// };

export const getRequestedValueLabel = (item, formData) => {
  if (!item || !formData) return "";

  const rawValue = formData?.[item.requestedValueFieldName];

  if (rawValue === undefined || rawValue === null || rawValue === "") {
    return "";
  }

  if (item?.options && Array.isArray(item.options)) {
    const found = item.options.find(
      (opt) => String(opt.value) === String(rawValue),
    );

    if (found) {
      // 🔥 handle both cases (text OR label)
      return found.label || found.text || "";
    }
  }

  return formatDynamicObject(safelyParse(stripHtml(rawValue)));
};
